import { queryBlogList } from '@queries'
import { IBlogPost } from '@types'
import { GetStaticProps, NextPage } from 'next'
import { getGraphQLData } from '../database/graphQL/apollo'
import { BlogContainer } from '@components/blog/BlogContainer'
import { AppLayout } from '@components'

export const getStaticProps: GetStaticProps<{
  blogPosts: IBlogPost[]
}> = async () => {
  const response = await getGraphQLData<{ allBlogs: IBlogPost[] }>(
    queryBlogList,
  )

  return {
    props: {
      blogPosts: response?.allBlogs.filter(
        post => post.category == 'Market Insights',
      ),
    },
    revalidate: 60,
  }
}

const Blogs: NextPage<{
  blogPosts: IBlogPost[]
}> = ({ blogPosts }) => {
  return (
    <AppLayout>
      <BlogContainer blogPosts={blogPosts} category="Market Insights" />
    </AppLayout>
  )
}

export default Blogs
